import moment from 'moment';

function EventSettingsCtrl($scope, $state, $stateParams, $q, sdkVenueService, eventService, sdkUtils, dateUtilsService, alertService, managementUserService,
  ERROR_MESSAGES, organizationService, mapperService, venueService, urlService, modalService) { //eslint-disable-line
  const vm = this;

  const currentUserOrganization = organizationService.getCurrentOrganization();

  vm.currentDateUTC = moment.utc();
  vm.loading = true;
  vm.venueId = $stateParams.venueId;
  vm.addEventInstance = {
    onSaving() {
      vm.saving = true;
    },
    onSaved(updatedEvent) {
      vm.saving = false;

      vm.eventForm = updatedEvent;
    }
  }; //this will get filled in by the Add-Event directive and allow us to call into it
  vm.saveEvent = function($event) {
    if ($event) $event.preventDefault();

    vm.addEventInstance.saveEvent();
  };

  vm.deleteEvent = function($event) {
    if ($event) $event.preventDefault();

    if (!vm.eventForm) return;

    if (vm.event.recurring && vm.event.recurring.enable) {
      modalService.confirmationEvent({
          size: 'sm',
          deleteMode: true
        })
        .then(result => {
          vm.deleting = true;

          return eventService.deleteById(vm.eventForm.id, {
              disableRecurring: !result.confirm.maintainLink
            })
            .then(() => {
              if (result && result.modalInstance) {
                result.modalInstance.close();
              }

              vm.deleting = false;

              $state.go($stateParams.backTo ? $stateParams.backTo : 'app.organization.events', {
                venueId: $stateParams.venueId,
                eventId: $stateParams.eventId,
                organizationId: currentUserOrganization.id,
                date: dateUtilsService.toUTCTimestampWithoutTime(vm.currentDateUTC)
              });
            })
            .catch(response => {
              vm.deleting = false;

              alertService.error(sdkUtils.getErrorFromResponse(response));
            });
        });
    } else {
      modalService.confirmation({
          modalHeader: `Delete Event '${vm.eventForm.name}'`,
          modalMessage: 'Are you sure you want to delete this event?',
          confirmBtnTxt: 'Delete Event',
          confirmingBtnTxt: 'Deleting...',
          size: 'sm'
        })
        .then(result => {
          if (result && result.confirm) {
            vm.deleting = true;

            return eventService.deleteById(vm.eventForm.id)
              .then(() => {
                vm.deleting = false;

                $state.go($stateParams.backTo ? $stateParams.backTo : 'app.organization.events', {
                  venueId: $stateParams.venueId,
                  eventId: $stateParams.eventId,
                  organizationId: currentUserOrganization.id,
                  date: dateUtilsService.toUTCTimestampWithoutTime(vm.currentDateUTC)
                });
              })
              .catch(response => {
                vm.deleting = false;

                alertService.error(sdkUtils.getErrorFromResponse(response));
              });
          }

          return null;
        });
    }
  };

  const dataPromises = [
    $scope.venuePromise,
    $scope.eventPromise
  ];

  $q.all(dataPromises)
    .then(results => {
      vm.venue = results[0];
      vm.event = results[1];

      const mappedEvent = mapperService.mapEventToUI(results[1]);

      vm.eventForm = mappedEvent;

      vm.loading = false;
    });
}

EventSettingsCtrl.$inject = [
  '$scope',
  '$state',
  '$stateParams',
  '$q',
  'jsSdk.venue',
  'jsSdk.event',
  'jsSdk.utils',
  'dateUtilsService',
  'alertService',
  'jsSdk.managementUser',
  'ERROR_MESSAGES',
  'organizationService',
  'mapperService',
  'venueService',
  'urlService',
  'modalService'
];

export default EventSettingsCtrl;



// WEBPACK FOOTER //
// ./src/components/eventSettings/eventSettingsCtrl.js